import {NetworkCodeParams} from '../../types/interfaces/configuration';

export class FetchNetworkCodeParamsList {
  static readonly type = '[ListNetworkCodeParams] Fetch All';

  constructor(public payload: NetworkCodeParams) {
  }
}
